/*!
 * Javascript
 * ---------------------------------------------------------------------------------
 */

import $ from './include/jquery-ext';

import AssetDefer from './include/asset-defer';
import countdown from './include/countdown';
import attribution from './include/attribution';

import exitIntent from 'exit-intent';
import {clearBodyLocks, lock, unlock} from 'tua-body-scroll-lock';
import * as lightbox from 'basiclightbox';

global.jQuery = global.$ = $;

if (!window.epos) window.epos = {};
typeof window.defaultPopup === 'undefined' && (window.defaultPopup = '#popup');

/**
 * Cloudamp attribution
 *
 */
try {
  attribution();
} catch (e) {
}

/**
 * Promo countdown
 */
if (!document.body.classList.contains('countdown--hide')) countdown();

/**
 * Fancybox replacement (iframe/video)
 */
if (document.querySelector('[data-fancybox="video"]')) {
  $(document).on('click', '[data-fancybox="video"]', function (e) {
    e.preventDefault();

    let id = this.href.match(/(v=|embed\/)([^?&/#]+)/);

    lightbox.create(
      `<iframe class="lightbox-frame" frameborder="0" allowfullscreen="" allowtransparency="true" src="${id ? `//www.youtube.com/embed/${id[2]}?autoplay=1&autohide=1&fs=0&rel=0` : this.href}"></iframe>`
    ).show();
  })
}

/**
 * Tab component
 */
$(document).on('click', '.tabs__toggle', function (e) {
  e.preventDefault();

  let $this = $(this);

  $this.closest('.tabs').find('.tabs__item').removeClass('show');
  $this.closest('.tabs').find('.tabs__toggle').removeClass('show');

  $(this.getAttribute('data-for')).addClass('show');
  $this.addClass('show');
});
/** END */

/**
 * App Tab component
 */
$(document).on('click', '.tabs__toggle', function (e) {
  e.preventDefault();

  let $this = $(this);

  $this.closest('.apptabs').find('.tabs__item').removeClass('show');
  $this.closest('.apptabs').find('.tabs__toggle').removeClass('show');

  $(this.getAttribute('data-for')).addClass('show');
  $this.addClass('show');
});
/** END */

/**
 * Off canvas nav toggle
 */
let view = $('body'),
  header = document.querySelector('.nnav__inner');

$(document).on('click', '.toggle a,.toggle__trigger', function (e) {
  e.preventDefault();
  view.toggleClass('show');
  if (view.hasClass('show')) {
    lock(header, {overflowType: 'clip'});
  } else {
    unlock(header, {overflowType: 'clip'});
  }
});

window.addEventListener('resize', () => {
  window.innerWidth >= 1024 && view.removeClass('show') && clearBodyLocks();
})
/** END */

let ntoggle = document.querySelector('.nhead__sect--toggle'),
  isNavMobileView = () => {
    return ntoggle ? getComputedStyle(ntoggle).display !== 'none' : false;
  },
  nnav = $('.nnav'),
  nnavback = $('.nnav__back'),
  navdowns = $('.nnav__item--drop'),
  navcols = $('.nnav__coltitle'),
  timeouts = [],
  hovertimeout,
  closetimeout;

if (nnav.length) {
  $(document).on('mouseover mouseout', '.nnav__item--drop > a', function (e) {
    clearTimeout(hovertimeout);
    clearTimeout(closetimeout);

    if (e.type === 'mouseout' || isNavMobileView()) return;

    hovertimeout = setTimeout(() => {
      $(this).trigger('ehover');
    }, 330);
  });

  $(document).on('click ehover', '.nnav__item--drop > a', function (e) {
    e.preventDefault();

    if (e.type === 'click') {
      clearTimeout(hovertimeout);
      clearTimeout(closetimeout);
    }

    if (this.parentNode.className.match(/nnav__item--show/) && e.type !== 'ehover') {
      nnav.removeClass('nnav--slide');

      $(this.parentNode).removeClass('nnav__item--show');
    } else {
      nnav.addClass('nnav--slide');

      navdowns.each((i, el) => {
        if (el === this.parentNode) return;

        el.classList.add('nnav__item--hiding');

        timeouts.push(setTimeout(() => {
          el.classList.remove('nnav__item--show')
          el.classList.remove('nnav__item--hiding')
          timeouts = [];
        }, 300))
      })

      $(this.parentNode).removeClass('nnav__item--hiding').addClass('nnav__item--show');
    }
  });

  let navBack = function (e) {
    e && e.preventDefault();

    nnav.removeClass('nnav--slide');
    navdowns.removeClass('nnav__item--hiding').removeClass('nnav__item--show');
  }

  $(document).on('click', '.nnav__back', navBack);

  let scrollDistance = 0,
    scrollThreshold = 15,
    scrollTimeout;
  $(document).on('click mouseout mouseover scroll', function (e) {
    if (e.type === 'scroll' && !isNavMobileView() && document.querySelector('.nnav__item--show')) {
      scrollDistance++;

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        scrollDistance = 0;
      }, 120);

      if (scrollDistance >= scrollThreshold) {
        navBack();
        return;
      }
    }
    clearTimeout(closetimeout);
    if (!nnav[0].contains(e.target)) {
      closetimeout = setTimeout(() => {
        navBack();
      }, e.type === 'click' ? 0 : 440);
    }
  })

  navcols.on('click', function () {
    var parent = this.parentNode;
    var siblings = parent.parentNode.children;

    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] !== parent) {
        siblings[i].classList.remove('nnav__col--show');
      }
    }

    parent.classList.toggle('nnav__col--show');
  })
}

/**
 * Promo logic (popup, scroll, show+hide, banner)
 */
let shownPromo = false,
  bodyClassAdded = false,
  popup = $('.popup'),
  popupdemo = $('#demo'),
  popuptrial = $('#trial'),
  popupcountry = $('#popupcountry'),
  popupexit = $('#popupexit'),
  popupsource = $('.popup__triggersource'),
  banner = $('.promo'),
  body = $('body'),
  scrollAndFocus = $('.scrollandfocus'),
  scrollTarget = $('.component.leadform,.component.capitalform');

function setCookie(name, value, days) {
  let expires = '';

  if (!name || !value) return;

  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  }

  document.cookie = name + "=" + value + expires + "; path=/";
}

function getCookie(name) {
  let result = document.cookie.match(new RegExp(name + '=([^=;]+)?'));
  return result && result[1];
}

let popupHasShown = false,
  hasInteracted = false,
  popupExitIntentShow = false,
  customScrollPercent = parseInt(body.data('popup-percent')),
  customTimeout = parseInt(body.data('popup-timeout')),
  scroll = e => {
    if ((window.scrollY > (customScrollPercent ? body.outerHeight() * (customScrollPercent / 100) : 240)) || body.data('popup-type') === 'immediate') {
      (!body.hasClass('promo--hide') && !body.hasClass('popup--hide')) && !shownPromo && !getCookie('popupShown') && (shownPromo = setTimeout(() => {
        if (body.data('popup-type') === 'exit') {
          popupExitIntentShow = true;
          return;
        }

        setCookie('popupShown', 'true', 0.025); // 36 mins
        popupHasShown = true;
        $(window.defaultPopup).addClass('show');
        popupsource.val('initial');

        !popupExitIntentShow && setTimeout(() => {
          popupExitIntentShow = true
        }, 2000)
      }, (customTimeout * 1000) || 550));
    }

    if (window.scrollY > 0 && bodyClassAdded) {
      return;
    }

    if (window.scrollY <= 0) {
      body.removeClass('scroll');
      bodyClassAdded = false;
      return;
    }

    hasInteracted = true;

    body.addClass('scroll');
    bodyClassAdded = true;
  };

document.addEventListener('scroll', scroll, {passive: true});
scroll();

$(document).on('click', '.popup', e => {
  if (!e.target.classList.contains('popup')) return;
  popup.removeClass('show');
  popupsource.val('');
})

$(document).on('click', '.popup-close', e => {
  e.preventDefault();
  popup.removeClass('show');
  popupsource.val('');
})

let cookiepopup = document.querySelector('.cookieconsent'),
  cookieConsented = () => {
    let types = ['preferences', 'statistics', 'marketing'],
      consentset = false;

    types.forEach(type => {
      if (getCookie('_acp' + type)) {
        consentset = true;
      }
    })

    return consentset;
  }

$(document).on('click', '.cookie--hide', e => {
  e.preventDefault();
  body.removeClass('consent--show');
  //setCookie('_acploc', 'preferences,statistics,marketing', 60);

  ['preferences', 'statistics', 'marketing'].forEach(type => {
    setCookie('_acp' + type, 'granted', 60);
  })

  window.dataLayer.push({
    'event': 'consent_accept'
  });
})

$(document).on('click', '.cookie--manage', e => {
  e.preventDefault();
  cookiepopup.classList.add('cookieconsent--manage');
})

/** END */

!cookieConsented() && body.addClass('consent--show');

let cookiepopupform = document.querySelector('.cookieconsent .consentform');

cookiepopupform && cookiepopupform.addEventListener('submit', e => {
  e.preventDefault();

  const formdata = new URLSearchParams(new FormData(e.target));

  formdata.append(e.submitter.name, '1');

  fetch(e.target.action, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    method: 'post',
    body: formdata
  }).then(() => {
    window.dataLayer.push({
      'event': 'consent_accept'
    });

    body.removeClass('consent--show');
  })
})

/**
 * Locale switcher
 */
$(document).on('change', '.localeswap,.localelegacy', e => {
  window.location = e.target.value;
})

/** END */


/**
 * Popup logic (show when href clicked, show immediately if URL param)
 */

// TODO: can this use the .demo-toggle class in code / cms?
// no need to duplicate logic, leaving in for compatibility
$(document).on('click', '.findoutmorebc', e => {
  e.preventDefault();
  body.addClass('bigcommerce');
  popupdemo.addClass('show');
});

$(document).on('click', '.demo-toggle', e => {
  e.preventDefault();
  popupdemo.addClass('show');
})

$(document).on('touchend', '.header-trigger-href', e => {
  e.preventDefault();
  e.stopPropagation();
  document.location.href = e.target.href;
})

$(document).on('click', '.popup-toggle', e => {
  if (e.target.closest('.popup-toggle').className.match(/popup-cust-/)) return;

  e.preventDefault();
  popupHasShown = true;
  setCookie('popupShown', 'true', 0.025);
  document.querySelector(window.defaultPopup).classList.add('show');

  let triggerElement = $(e.target).closest('[data-formtrigger]');

  popupsource.val(triggerElement.attr('data-formtrigger') || `clicked:${e.target.innerText}`);

  !popupExitIntentShow && setTimeout(() => {
    popupExitIntentShow = true
  }, 6000)
})

$(document).on('click', '.trial-toggle', e => {
  e.preventDefault();
  popuptrial.addClass('show');
});

$(document).on('click', '.popcountrytoggle', e => {
  e.preventDefault();
  popupcountry.addClass('show');
});

let shownExit = false,
  disableExit = exitIntent({
    threshold: 30,
    maxDisplays: Number.MAX_SAFE_INTEGER,
    onExitIntent: () => {
      if (!shownExit && popupExitIntentShow && hasInteracted && !$(window.defaultPopup).hasClass('show') && !popupdemo.hasClass('show') && !popuptrial.hasClass('show')) {
        setCookie('shownExit', 'true', 5); // 5 days
        shownExit = true;
        (body.data('popup-type') === 'exit' ? $(window.defaultPopup) : popupexit).addClass('show');
      }
    }
  })

scrollAndFocus.on('click', function (e) {
  if (!scrollTarget.length) return;

  e.preventDefault();

  $('html').animate({
    scrollTop: scrollTarget.offset().top - 120
  }, 1000);

  $('.component.leadform input,.component.capitalform input').first().focus();
});


let showForm = document.location.href.match(/(submitfail|popupform)=([a-z0-9_\-]+)/i),
  noTriggerForm = document.querySelector('.__notriggerpopup');

if (showForm && !noTriggerForm) {
  if (body.hasClass('popup--hide') && scrollTarget.length) {

    $(document).ready(function () {
      scrollAndFocus.trigger('click');
    });
  } else {

    let currentForm = document.getElementById(showForm[2]) || document.getElementById('popup');

    if (currentForm && currentForm.classList.contains('popup')) {
      currentForm.classList.add('show');
    }
  }
}

/** END */

function logout() {
  /* stub */
}

/** Job accordion */
var acc = document.getElementsByClassName("jobaccordion__toggle");

for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function (e) {
    e.preventDefault();
    this.className = this.className.match(/ ?active/) ? this.className.replace(/ ?active/, '') : this.className + ' active';
  });
}
/** END */

let isTouchScreen = false;
document.addEventListener('touchstart', () => {
  isTouchScreen = true;
}, {passive: true})

let navTimeout;
$('.nav__dropdownparent > a').on('click mouseover mouseout', function (e) {

  // weird fix for ios devices firing a billion click related events
  if (isTouchScreen && e.type.match(/mouse(over|out)/)) {
    return;
  }

  if (isTouchScreen && e.type === 'click') {
    e.preventDefault();
  }

  $('.nav__dropdownparent a').not(this).removeClass('nav__dropdown--active');

  if (e.type === 'click') {
    $(this).toggleClass('nav__dropdown--active');
  }

  if (e.type === 'mouseover') {
    $(this).addClass('nav__dropdown--active');
  } else if (e.type === 'mouseout') {
    $(this).removeClass('nav__dropdown--active');
  }
});

var resizeTimer;
$(window).on('resize', function (e) {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    if (isTouchScreen) {
      $('.nav__dropdownparent a').removeClass('nav__dropdown--active');
    }
    //$('body').removeClass('show');
  }, 250);
});

let cartsubmitting = {}; // allow concurrent requests using associative array
$(document).on('click', '.cartaddajax', function (e) {
  e.preventDefault();

  if (cartsubmitting[this.href]) return;

  cartsubmitting[this.href] = true;

  this.className += ' submitting';

  fetch(this.href, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    cache: 'no-cache'
  }).then(async (response) => {
    let data = await response.text();
    cartsubmitting[this.href] = false;
    $(this)[(data === 'true' ? 'add' : 'remove') + 'Class'](this.getAttribute('data-xclass')).removeClass('submitting')
  }).catch((error) => {
    cartsubmitting[this.href] = false;
    console.error('cartaddajax failed', error);
    window.location.href = this.href; // fallback
  })
})

$(document).on('click', '.docs [data-fieldname]', function () {
  !this.getAttribute('contenteditable') && this.setAttribute('contenteditable', 'true');
})

function getParam(p) {
  var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getExpiryRecord(value) {
  var expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 day expiry in milliseconds

  var expiryDate = new Date().getTime() + expiryPeriod;
  return {
    value: value,
    expiryDate: expiryDate
  };
}

function addGclid() {
  var gclidParam = getParam('gclid'),
    gclidRecord = null,
    currGclidFormFields = document.querySelectorAll('.offclickid-pop'),

    gclsrcParam = getParam('gclsrc'),
    isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1;

  if (gclidParam && isGclsrcValid) {
    gclidRecord = getExpiryRecord(gclidParam);
    localStorage.setItem('gclid', JSON.stringify(gclidRecord));
  }

  var gclid = gclidRecord || JSON.parse(localStorage.getItem('gclid'));
  var isGclidValid = gclid && new Date().getTime() < gclid.expiryDate;

  if (currGclidFormFields && isGclidValid) {
    for (var i = 0; i < currGclidFormFields.length; i++) {
      currGclidFormFields[i].value = gclid.value;
    }
  }
}

window.addEventListener('load', addGclid);

// msclkid
let msclkid = getParam('msclkid');
if (msclkid) {
  setCookie('_msclkid', msclkid, 7);
}

// fbclid
let fbclid = getParam('fbclid');
if (fbclid) {
  setCookie('_fbclid', fbclid, 7);
}

// fix overflow tables
for (var i = 0, e = document.querySelectorAll('table'); i < e.length; i++) {
  let curr = e[i],
    wrap = document.createElement('div');

  wrap.style.overflowX = 'scroll';

  wrap.innerHTML = curr.outerHTML;
  curr.parentNode.insertBefore(wrap, curr);

  curr.remove();
}

$('.fullleadform input').on('keydown keyup keypress', function () {
  if (this.value && !this.parentNode.parentNode.className.match(/edited/)) {
    this.parentNode.parentNode.className += ' edited';
  }
})

$(document).on('click', '.productaccordion__item', function () {
  $(this).toggleClass('productaccordion__item--open');
});

$(document).on('click', '.faq__item', function () {
  $(this).toggleClass('faq__item--open');
});

// Open / close footer link list based on the clicked column
$(document).on('click', '.footer__col', function () {
  $(this).toggleClass('footer__item--open');
});

$(document).on('click', 'a[href*="#"]', function (event) {
  if (this.pathname !== location.pathname || this.classList.contains('no-anchor-scroll')) return;

  let anchor = this.getAttribute('href').replace(/[^#]*(#.*)/, '$1');
  if (anchor.length <= 1) return;

  let target = $(anchor);
  if (!target.length) return;

  event.preventDefault();

  window.scrollTo({
    top: target.offset().top - 250,
    behavior: 'smooth'
  })

  history.pushState(null, '', this.getAttribute('href'));
});

let countrybanner = document.querySelector('.countrybanner'),
  countryselect = document.querySelector('.countrybanner__list'),
  countrybutton = document.querySelector('.countrybanner__navigate'),
  countryclose = document.querySelector('.countrybanner__close'),
  userlocale = getCookie('RecommendedLocale');

if (countrybanner) {
  if (countryselect && userlocale) {
    let useroption = document.querySelector(`.countrybanner option[data-locale="${userlocale}"]`);
    useroption && (useroption.selected = true);

    countrybutton.href = countryselect.value;

    countryselect.addEventListener('change', (e) => {
      countrybutton.href = e.target.value;
    })
  }

  countryclose.addEventListener('click', e => {
    e.preventDefault();
    countrybanner.classList.remove('countrybanner--show');
    setCookie('_hideCountrySelector', true, 7);
  })

  countrybutton.addEventListener('click', e => {
    setCookie('_hideCountrySelector', true, 7);
  })

  if (!getCookie('_hideCountrySelector') && userlocale && userlocale !== document.documentElement.lang.replace('-', '_')) {
    countrybanner.classList.add('countrybanner--show');
  }
}

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio < 0.1) return;
      const target = entry.target;
      if (target.matches('form[id^="Form_LeadForm"]')) {
        window.dataLayer.push({'event': 'leadFormShow'});
      } else if (target.matches('#trial')) {
        window.dataLayer.push({'event': 'trialFormShow'});
      } else if (target.matches('#demo')) {
        window.dataLayer.push({'event': 'demoFormShow'});
      }
    });
  }, {threshold: 0.1});

  const leadForms = document.querySelectorAll('form[id^="Form_LeadForm"]');
  const trialForm = document.querySelector('#trial');
  const demoForm = document.querySelector('#demo');


  leadForms.forEach(el => observer.observe(el));

  if (trialForm) observer.observe(trialForm);
  if (demoForm) observer.observe(demoForm);
}

document.querySelectorAll('a[href*="//checkout.eposnow.com/"]').forEach((el) => {
  let href = new URL(el.href),
    ca_data = window.localStorage.getItem('_ca_data'),
    exclude = ['timestamp'],
    fbclid = getCookie('_fbclid');

  if (ca_data) {
    ca_data = JSON.parse(ca_data)
  }

  for (const [key, value] of Object.entries(ca_data)) {
    if (!value || exclude.indexOf(key) >= 0 || value.match(/(\(direct\)|none)/)) continue;

    href.searchParams.set(`ca_${key.toLowerCase()}`, value);
  }

  if (fbclid) {
    href.searchParams.set('ca_fbclid', fbclid);
  }

  el.href = href.toString();
})

/**
 * Only load JS when required elements are in view
 */
const Requirements = new AssetDefer();

let themeDir = '_resources/themes/default/dist';

Requirements.js('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', '.trustpilot-widget', {threshold: 0.1}, 0.1);

Requirements.js(`${themeDir}/js/phone-input.js`, 'input.format--phone', {threshold: 0.1}, 0.1);
Requirements.css(`${themeDir}/js/thirdparty/phone-input/phone-input.css`, 'input.format--phone', {threshold: 0.1}, 0.1);

Requirements.js(`${themeDir}/js/adv_teasers.js`, 'form', {threshold: 0.1}, 0.1);

Requirements.js(`${themeDir}/js/recaptcha.js`, 'form', {threshold: 0.1}, 0.1);
Requirements.js(`${themeDir}/js/gcomm.js`, '[class*="ecomm--"],.cartform', {threshold: 0.1}, 0.1);
Requirements.js(`${themeDir}/js/macy.js`, '#footer', {threshold: 0.1}, 0.1);
Requirements.js(`${themeDir}/js/forms.js`, 'form', {threshold: 0.1}, 0.1);

Requirements.js(`${themeDir}/js/dki.js`, '[data-dki-replace]', {threshold: 0.1}, 0.1);

if (document.body.classList.contains('xmastime')) {
  Requirements.js(`${themeDir}/js/snow.js`, '.popup', {threshold: 0.1}, 0.1);
}

document.querySelectorAll('[data-js-visible]').forEach((el) => Requirements.js(el.dataset.jsVisible, [el], {threshold: 0.1}, 0.1));
document.querySelectorAll('[data-css-visible]').forEach((el) => Requirements.css(el.dataset.cssVisible, [el], {threshold: 0.1}, 0.1));

window.Requirements = Requirements;

let cartData = getCookie("cart_items");

if (cartData) {
  cartData = JSON.parse(decodeURIComponent(cartData));
  let totalItems = cartData.totalItems || 0;
  if (totalItems > 0) {
    document.querySelector('.nhead__ecomcartwrapper').classList.remove('nhead__ecomcartwrapper--hide');
    document.querySelector('.ecomcartwrappe__quantity').textContent = totalItems;
  }
}
